import { SharedSelectTreeChangeEventOutput } from '@customer-portal/shared/models';
import { FilterValue, GridConfig } from '@customer-portal/shared/models/grid';

import { NotificationFilterKey } from '../../constants';
import { NotificationModel } from '../../models';

export class RestoreNotificationFilters {
  static readonly type = '[Notification Details] Restore Filters';

  constructor(
    public companies?: number[],
    public services?: number[],
    public sites?: number[],
    public categories?: string[],
  ) {}
}
export class LoadInitialNotificationsAndFilters {
  static readonly type =
    '[Notifications Details] Load Initial Notifications And Filters';
}

export class LoadNotificationsListSuccess {
  static readonly type =
    '[Notifications List] Load Notifications List Items Success';

  constructor(public notifications: NotificationModel[]) {}
}
export class LoadNotificationsListFail {
  static readonly type = '[Notifications List] Load Notifications List Fail';

  constructor(public error: string) {}
}

export class UpdateUnreadOnlyFilter {
  static readonly type = '[Notifications] Load Unread Only';

  constructor(public isUnreadOnly: boolean) {}
}

export class LoadFilteredNotifications {
  static readonly type = '[Notifications] Load Filtered Notifications';
}

export class MarkNotificationAsRead {
  static readonly type = '[Notifications] Mark Notification As Read';

  constructor(public id: number) {}
}

export class NavigateFromNotification {
  static readonly type = '[Notifications] Navigate From Notification';

  constructor(
    public id: string,
    public type: string,
    public certificateNumber?: string,
  ) {}
}

export class UpdateGridConfig {
  static readonly type = '[Notifications List] Update Grid Config';

  constructor(public gridConfig: GridConfig) {}
}

export class UpdateNotificationFilterCategories {
  static readonly type = '[Notification Filter] Update Categories';

  constructor(public data: string[]) {}
}

export class UpdateNotificationFilterServices {
  static readonly type = '[Notification Filter] Update Services';

  constructor(public data: number[]) {}
}

export class UpdateNotificationFilterCompanies {
  static readonly type = '[Notification Filter] Update Companies';

  constructor(public data: number[]) {}
}

export class UpdateNotificationFilterSites {
  static readonly type = '[Notification Filter] Update Sites';

  constructor(public data: SharedSelectTreeChangeEventOutput) {}
}

export class UpdateNotificationFilterByKey {
  static readonly type = '[Notification Filter] Update by Key';

  constructor(
    public data: unknown,
    public key: NotificationFilterKey,
  ) {}
}

export class SetNavigationGridConfig {
  static readonly type = '[Notifications] Set Navigation Grid Config';

  constructor(public notificationsFilters: FilterValue[]) {}
}

export abstract class NavigateFromNotificationsListAction {
  constructor(public notificationsFilters: FilterValue[]) {}
}

export class NavigateFromNotificationsListToContractsListView extends NavigateFromNotificationsListAction {
  static readonly type =
    '[Notifications] Navigate From Notification To Contracts List View';
}

export class NavigateFromNotificationsListToFinancialsListView extends NavigateFromNotificationsListAction {
  static readonly type =
    '[Notifications] Navigate From Notification To Financials List View';
}

export class NavigateFromNotificationsListToScheduleListView extends NavigateFromNotificationsListAction {
  static readonly type =
    '[Notifications] Navigate From Notification To Schedule List View';
}

export class ResetNotificationsFilters {
  static readonly type = '[Notifications] Reset All Notification Filters';
}

export class ResetNotificationsState {
  static readonly type = '[Notifications] Reset Notifications State';
}
